import type { VendorCompany } from "./VendorCompany";

export type VendorPartner = {
	allowMessage: boolean;
	id: number;
	partnerVendorCompany: VendorCompany;
	seq: number;
};

/**
 * partner側から見た、一次請けのvendor_partners
 */
export type RelatedVendorPartner = {
	allowMessage: boolean;
	id: number;
	seq: number;
	vendorCompany: VendorCompany;
};

export const convertToComboBoxOption = (
	vendorPartner: VendorPartner
): { label: string; value: string } => ({
	label: vendorPartner.partnerVendorCompany.name,
	value: String(vendorPartner.partnerVendorCompany.id)
});
